import { LoadingOutlined } from "@ant-design/icons";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addCalenderDetails,
  deleteCalenderEvent,
} from "../services/awsServices";
import AddEventsModal from "./AddEventsModal";
import DeleteEventsModal from "./DeleteEventsModal";
import { createEventId } from "./event-utils";
import { getUserCalendarDetails } from "../slices/userSlice";
import toastMessage from "../utils/toastMessage";

const DemoApp = ({
  toggleModal,
  isModalVisible,
  isFromSideCalender,
  filteredEvents,
  editModal,
}) => {
  const calenderRef = useRef();
  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const [initialCalenderData, setInitialCalenderData] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log("🚀 ~ loading:", loading);
  const [currentEvents, setCurrentEvents] = useState([]);
  // const [isModalVisible, setIsModalVisible] = useState(false);
  const [newEventTitle, setNewEventTitle] = useState("");
  const [selectedInfo, setSelectedInfo] = useState(null);
  const dispatch = useDispatch();
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const [eventToDelete, setEventToDelete] = useState(null); // New state to hold the event to delete
  const [formData, setFormData] = useState({
    Title: "",
    EventType: "Meetings",
    EventDate: dayjs(selectedInfo?.startStr),
    StartTime: "",
    EndTime: "",
    Users: [],
    Description: "",
    MeetingLink: "",
  });

  const handleEditDataSet = (details, dateValue) => {
    const dataToBeSet = {
      Title: details.title,
      EventType: details.extendedProps?.eventType,
      EventDate: dayjs(dateValue.range.start),
      StartTime: dayjs(dateValue.range.start),
      EndTime: dayjs(dateValue.range.end),
      Users: details.extendedProps?.users,
      Description: details.extendedProps?.description,
      MeetingLink: details.extendedProps?.meetingLink,
    };
    setFormData(dataToBeSet);
  };

  const transformApiDataToEvents = () => {
    return filteredEvents.map((item) => ({
      id: item.SK, // Or generate a new ID if necessary
      primaryId: item.PK,
      title: item.Title,
      start: item.EventDate,
      description: item.Description,
      startTime: item.StartTime,
      endTime: item.EndTime,
      eventType: item.EventType,
      users: item.Users,
      meetingLink: item.MeetingLink,
    }));
  };
  const showModal = (selectInfo) => {
    toggleModal(true);
    setSelectedInfo(selectInfo);
    setFormData({
      ...formData,
      EventDate: dayjs(selectInfo.startStr),
    });
  };

  const handleEventDrop = async (info) => {
    const payload = {
      SK: info.event.id,
      PK: info.event.extendedProps.primaryId,
      EventDate: info.event.start,
      Title: info.event.title,
      EventType: info.event.extendedProps.eventType,
    };
    addCalenderDetails(payload).then((res) => {
      if (res) {
        setLoading(true);
        dispatch(getUserCalendarDetails()).unwrap();
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    const transformedEvents = transformApiDataToEvents();
    setInitialCalenderData(transformedEvents);
  }, [filteredEvents]);

  const handleOk = () => {
    toggleModal(false);
    console.log(formData, selectedInfo, " = formData, selectedInfo, ");
    if (formData && selectedInfo) {
      const calendarApi = selectedInfo.view.calendar;
      calendarApi.unselect(); // clear date selection

      calendarApi.addEvent({
        id: Math.floor(Math.random() * 100),
        title: formData.Title,
        start: selectedInfo.startStr,
        end: selectedInfo.endStr,
        allDay: selectedInfo.allDay,
      });
    } else {
      setInitialCalenderData((prev) => [
        ...prev,
        {
          id: createEventId(),
          title: formData.Title,
          start: dayjs(formData.EventDate).format("YYYY-MM-DD"),
        },
      ]);
    }
    setFormData({
      newEventTitle: "",
      selectedTags: [],
      date: dayjs(selectedInfo?.endStr),
      time: [],
      people: "",
      description: "",
    });
    setNewEventTitle("");
    setSelectedInfo(null);
  };

  const handleCancel = () => {
    toggleModal(false);
    setNewEventTitle("");
    setSelectedInfo(null);
  };

  const handleDateSelect = (selectInfo) => {
    console.log(selectInfo, " = sekectstadkjskajsjjsd");
    showModal(selectInfo);
  };

  // Updated handleEventClick to show confirmation modal
  const handleEventClick = (clickInfo) => {
    setIsDeleteModalVisible(true); // Show the delete confirmation modal
    setEventToDelete(clickInfo); // Store the clicked event for potential deletion
  };

  // Function to confirm deletion

  const confirmDeletion = () => {
    if (eventToDelete) {
      eventToDelete.event.remove();
      const payload = {
        PK: eventToDelete?.event._def.extendedProps.primaryId,
        SK: eventToDelete?.event._def.publicId,
      };
      const res = deleteCalenderEvent(payload);
      if (res) {
        toastMessage(res.message || "Event Delete Successfully", "success");
      }
      setIsDeleteModalVisible(false); // Close the modal after deletion
      setEventToDelete(null); // Clear the stored event
    }
  };

  // Function to cancel deletion
  const cancelDeletion = () => {
    setIsDeleteModalVisible(false);
    setEventToDelete(null);
  };

  const handleEvents = (events) => {
    setCurrentEvents(events);
  };

  return (
    <div className="demo-app h-full">
      <AddEventsModal
        setFormData={setFormData}
        formData={formData}
        handleCancel={handleCancel}
        handleOk={handleOk}
        isModalVisible={isModalVisible}
      />
      <DeleteEventsModal
        editModal={editModal}
        data={eventToDelete}
        isDeleteModalVisible={isDeleteModalVisible}
        confirmDeletion={confirmDeletion}
        cancelDeletion={cancelDeletion}
        handleEdit={handleEditDataSet}
      />
      <div className="demo-app-main h-full">
        <FullCalendar
          height={"100%"}
          plugins={[
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin,
            listPlugin,
          ]}
          headerToolbar={{
            left: "prev,next",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
          }}
          eventDrop={handleEventDrop}
          droppable={true}
          initialView="dayGridMonth"
          editable={true}
          selectable={true}
          selectMirror={true}
          dayMaxEvents={true}
          weekends={weekendsVisible}
          events={initialCalenderData}
          select={handleDateSelect}
          eventClick={handleEventClick}
          eventsSet={handleEvents}
          ref={calenderRef}
        />
      </div>
    </div>
  );
};

export default DemoApp;
